// merge menu quick updates (settings.menu, keyed by product id) into the menu
// so downstream consumers (product page, cart) see the updated data
export default function applyMenuQuickUpdates (menu, quickUpdates) {
  if (!menu || !menu.subMenus || !quickUpdates) { return menu }
  menu.subMenus.forEach((subMenu) => {
    (subMenu.products || []).forEach((product) => {
      const update = quickUpdates[product.id]
      if (!update) { return }
      if (update.name?.en) {
        product.name = Object.assign({}, product.name, { en: update.name.en })
      }
      if (update.description?.en) {
        product.description = Object.assign({}, product.description, { en: update.description.en })
      }
      if (update.price !== undefined && update.price !== null) {
        product.price = update.price
      }
    })
  })
  return menu
}
